"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniqueValueRaster = void 0;
const raster_1 = require("./raster");
/**
 * Buckets is formed by using uniques values in the data
 */
class UniqueValueRaster extends raster_1.Raster {
    constructor(data, bounds, colorRange, options) {
        super(data, bounds, colorRange, options);
        // Pixels with 0 value is transparent
        this.noDataValues = [0];
        // Use keyed index function to find the color for the value
        this.colorIndexFnType = raster_1.ColorIndexFnType.KEYED;
        this.ranges = this.computeRanges();
        this.imageData = this.computeImagedata();
    }
    computeRanges() {
        const ordered = this.orderedValues;
        let currIndex = 0;
        const mappingCount = {};
        while (currIndex < ordered.length) {
            const currVal = ordered[currIndex];
            const lastIndex = ordered.lastIndexOf(currVal);
            if (currVal > 0) {
                mappingCount[currVal] = lastIndex - currIndex + 1;
            }
            if (lastIndex !== -1) {
                currIndex = lastIndex + 1;
            }
            else {
                currIndex = ordered.length;
            }
        }
        //Get unique values and sort by count of a unique value (by area)
        return Array.from(new Set(ordered))
            .filter((val) => !!mappingCount[val])
            .sort((valA, valB) => mappingCount[valB] - mappingCount[valA]);
    }
}
exports.UniqueValueRaster = UniqueValueRaster;
